/* eslint-disable prefer-arrow/prefer-arrow-functions */
import React from 'react';
import styled from 'styled-components';
import {
  IAsymmetryReportState,
  IAsymmetryResult,
} from '../../../data/providers/reports/asymmetryReportProvider';
import { formatDayFromUtc } from '../../../utils/date';
import { Column } from '../../layout/Column';
import { Card } from '../../shared/card/Card';
import { CardBody } from '../../shared/card/CardBody';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../shared/card/CardHeader';
import { Notable } from '../../shared/pdf/Notable';
import { EPdfMode, isPdf } from '../../shared/pdf/Pdf';
import { Graph } from './Graph';
import { AsymmetryLegend } from './Legend';

interface IProps {
  reportState: IAsymmetryReportState;
  pdfMode?: EPdfMode;
}

export const GraphCard = (props: IProps): React.ReactElement => {
  return (
    <React.Fragment>
      {props.reportState.results.map(
        (result: IAsymmetryResult, index: number): React.ReactElement => {
          return (
            <PdfCardWrapper
              pdf={isPdf(props.pdfMode)}
              key={`result-${index}`}
              style={{ marginBottom: '20px' }}
            >
              <Notable pdf={isPdf(props.pdfMode)}>
                <Card
                  inverse={props.pdfMode === EPdfMode.PRINT}
                  style={{ height: 'auto' }}
                >
                  <Column>
                    <CardHeader inverse={props.pdfMode === EPdfMode.PRINT}>
                      <CardHeaderLeft>
                        <h6>{titleFormatter(result.meta.label)}</h6>
                      </CardHeaderLeft>
                      <CardHeaderRight>
                        <AsymmetryLegend />
                      </CardHeaderRight>
                    </CardHeader>
                    <CardBody withoutFooter>
                      <Graph
                        data={[result]}
                        pdfMode={props.pdfMode}
                        entityType={props.reportState.entityType}
                      />
                    </CardBody>
                  </Column>
                </Card>
              </Notable>
            </PdfCardWrapper>
          );
        }
      )}
    </React.Fragment>
  );
};

function titleFormatter(value: number | string): string {
  return +value > 12875256000 ? formatDayFromUtc(+value) : value.toString();
}

const PdfCardWrapper = styled.div<{ pdf?: boolean }>`
  flex: 1;
  padding: 2px;
`;
